module.exports = __webpack_public_path__ + "img/business-rules.d84d3a2f.svg";